module.exports = __webpack_public_path__ + "static/media/16.73679619.png";